import { Box, Typography } from '@mui/material';
import { RevisionStatus } from 'utils/contracts';

interface StatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case RevisionStatus.SUCCESS:
        return '#4caf50';
      case RevisionStatus.FAILED:
        return '#f44336';
      case RevisionStatus.PENDING:
      case RevisionStatus.PROCESSING:
        return '#ff9800';
      case RevisionStatus.VALIDATING:
        return '#2196f3';
      case RevisionStatus.CHECKED:
        return '#3f51b5';
      case RevisionStatus.RESOLVING:
        return '#9c27b0';
      default:
        return '#9e9e9e';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case RevisionStatus.SUCCESS:
        return 'Success';
      case RevisionStatus.FAILED:
        return 'Failed';
      case RevisionStatus.PENDING:
        return 'Pending';
      case RevisionStatus.PROCESSING:
        return 'Processing';
      case RevisionStatus.VALIDATING:
        return 'Validation';
      case RevisionStatus.CHECKED:
        return 'Checked';
      case RevisionStatus.RESOLVING:
        return 'Resolving';
      default:
        return status;
    }
  };

  const color = getStatusColor(status);
  const label = getStatusLabel(status);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        border: `1px solid ${color}`,
        borderRadius: '16px',
        padding: size === 'small' ? '2px 8px' : '4px 12px',
        backgroundColor: color
      }}
    >
      <Typography
        variant={size === 'small' ? 'body2' : 'body1'}
        sx={{
          color: "white",
          fontWeight: 500,
          lineHeight: 1.2
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StatusChip; 